var buildChart = require("./build");

module.exports = function() {
	if (document.querySelector(".chart")) {
		buildChart();
	}
}